

// export default WelcomePage
import React, { useState, useEffect, Profiler } from "react";
import Logo from "../Assets/images/fav-icon.png";
import SideBar from "../Includes/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import Analysis from "../Analysis/Analysis";
import Permissionpage from "./Permissionpage";
import Upload from "../Uploads/Upload";
import SupplementFileUploadModal from "../Uploads/supplementpopup";
import AddionalAgentselect from "../Uploads/AddionalAgentselect";
import AddionalAgentAssistantselect from "../Uploads/AddionalAgentassistant";
import Addionalappsselect from "../Uploads/AddionalAppfeatures";
import RecentUploads from "../RecentUploads/UploadPage";
import SettingsPage from "../SettingsPage/SettingsPage";
import { Modal, Button } from "react-bootstrap";
//pass request back end
import axios from "axios";

import { API_BASE_URL } from "../../global";

const WelcomePage = () => {
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (localStorage.getItem("userid")) {
  //     fetchAllCases()
  //     fetchTokenDeatils();
  //     // Repeat every 3 minutes (180,000 ms)
  //     const intervalId = setInterval(() => {
  //       fetchAllCases();
  //       fetchTokenDeatils();
  //     }, 7000);

  //     // Cleanup on unmount
  //     return () => clearInterval(intervalId);
  //   } else {
  //     navigate("/")
  //   }
  // }, [])


  const [resetUpload, setResetUpload] = useState(null);

  const [fileName, setFileName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [activateTransition, setActivateTransition] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(localStorage.getItem("view") === "analysis");
  const [showSettings, setShowSettings] = useState(localStorage.getItem("view") === "settings");
  const [showRecentUpload, setRecentUpload] = useState(localStorage.getItem("view") === "recentUpload");
  const [showApprovalpage, setshowApprovalpage] = useState(localStorage.getItem("view") === "approvalpage");
  const [approvalstatus, setapprovalstatus] = useState(1);
  const [settingsStep, setSettingsStep] = useState("step1");
  const [timeoutId, setTimeoutId] = useState(null);
  const [hasUploadInProgress, setHasUploadInProgress] = useState(false);

  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [issupplementModalOpen, setIssupplementModalOpen] = useState(false);
  const [selectedfile, setselectedFile] = useState(null);
  const [isaddionalagentModalOpen, setIsaddionalagentModalOpen] = useState(false);
  const [isaddionalagentassistantModalOpen, setisaddionalagentassistantModalOpen] = useState(false);
  const [isaddionalappsModalOpen, setisaddionalappsModalOpen] = useState(false);



  const handleResetClick = () => {
    if (resetUpload) {
      resetUpload(); // ✅ calls child’s resetForm()
    } else {
      console.warn("Reset function not ready yet");
    }
  };



  const OpensupplementModal = (item) => {
    askBeforeLeave(() => {
      setIssupplementModalOpen(true);
      setselectedFile(item);
    })
  };

  // Function to close the modal
  const closesupplementModal = () => {
    setIssupplementModalOpen(false);
    setselectedFile(null)
  };

  const OpenAddionalagentModal = (item) => {
    askBeforeLeave(() => {
      setIsaddionalagentModalOpen(true);
      setselectedFile(item);
    })
  };

  // Function to close the modal
  const closeAddionalagentModal = () => {
    setIsaddionalagentModalOpen(false);
    setselectedFile(null)
  };
  const OpenAddionalagentassistantModal = (item) => {
    askBeforeLeave(() => {
      setisaddionalagentassistantModalOpen(true);
      setselectedFile(item);
    })
  };

  // Function to close the modal
  const closeAddionalagentassistantModal = () => {
    setisaddionalagentassistantModalOpen(false);
    setselectedFile(null)
  };
  const OpenAddionalappsModal = (item) => {
    askBeforeLeave(() => {
      setisaddionalappsModalOpen(true);
      setselectedFile(item);
    })
  };

  // Function to close the modal
  const closeAddionalappsModal = () => {
    setisaddionalappsModalOpen(false);
    setselectedFile(null)
  };


  const askBeforeLeave = (action) => {
    if (hasUploadInProgress) {
      console.log("hello")
      setPendingAction(() => action);
      setShowLeaveModal(true);
      return;
    }
    action();
  };
  const handleshowApproval = (statustype) => {
    localStorage.setItem("view", "approvalpage");
    setapprovalstatus(statustype);
    setshowApprovalpage(true);
    setRecentUpload(false);
    setShowAnalysis(false);
    setShowSettings(false);
    setFileUploaded(false);
  };

  const handleShowUploads = () => {
    // if (hasUploadInProgress) {
    //   if (!window.confirm("You have an upload in progress. Are you sure you want to leave?")) {
    //     return;
    //   }
    // }
    askBeforeLeave(() => {
      localStorage.setItem("view", "upload");
      setRecentUpload(false);
      setShowAnalysis(false);
      setShowSettings(false);
      setFileUploaded(false);
      setshowApprovalpage(false);
    })
  };

  const handleShowSettings = (step = "step1") => {
    // if (hasUploadInProgress) {
    //   if (!window.confirm("You have an upload in progress. Are you sure you want to leave?")) {
    //     return;
    //   }
    // }

    //console.log(step)
    // step1 is active tab is user Profile
    // step2 is active tab is billing
    askBeforeLeave(() => {
      if (step === "step2") {
        setSettingsStep(step);
      } else {
        setSettingsStep("step1");
      }

      localStorage.setItem("view", "settings");
      setShowSettings(true);
      setRecentUpload(false);
      setShowAnalysis(false);
      setshowApprovalpage(false);
    })
  };

  const handleShowRecentUpload = () => {

    // if (hasUploadInProgress) {
    //   if (!window.confirm("You have an upload in progress. Are you sure you want to leave?")) {
    //     return;
    //   }
    // }
    askBeforeLeave(() => {
      localStorage.setItem("view", "recentUpload");
      setRecentUpload(true);
      setShowAnalysis(false);
      setShowSettings(false);
      setshowApprovalpage(false);
    })
  };

  const handleFileChange = (e) => {
    // if (e.target.files.length > 0) {
    //   const selectedFile = e.target.files[0];
    //   // setFileName(selectedFile.name);
    //   setFileName(prev => prev === selectedFile.name ? prev : selectedFile.name);
    setFileUploaded(true);

    requestAnimationFrame(() => {
      setActivateTransition(true);
    });
    // }
  };

  const handleFileClose = () => {
    setActivateTransition(false);
    setHasUploadInProgress(false);
    setTimeout(() => {
      setFileUploaded(false);
      setFileName("");
    }, 200);
  };

  const handleContinueClick = () => {
    // if (hasUploadInProgress) {
    //   if (!window.confirm("You have an upload in progress. Are you sure you want to continue?")) {
    //     return;
    //   }
    // }
    // askBeforeLeave(() => {
    localStorage.setItem("view", "analysis");
    setShowAnalysis(true);
    setShowSettings(false);
    setRecentUpload(false);
    setshowApprovalpage(false);
    // })

  };
  const handleContinueClicksidebar = () => {
    // if (hasUploadInProgress) {
    //   if (!window.confirm("You have an upload in progress. Are you sure you want to continue?")) {
    //     return;
    //   }
    // }
    askBeforeLeave(() => {
      localStorage.setItem("view", "analysis");
      setShowAnalysis(true);
      setShowSettings(false);
      setRecentUpload(false);
      setshowApprovalpage(false);
    })

  };


  const [allCasesData, setAllCasesData] = useState([]);


  const fetchAllCases = async () => {

    const userId = localStorage.getItem("userid");
    if (!userId) {
      navigate("/");
      return [];
    }

    try {
      const response = await axios.get(`${API_BASE_URL}upload?uId=${userId}`);

      const allCases = response.data?.case_data || [];
      if (response.data?.user_approval_status === 1) {
        setshowApprovalpage(false);
        setAllCasesData(allCases);
        const currentView = localStorage.getItem('view');
        console.log(currentView)
        if (currentView === "recentUpload") {
          localStorage.setItem("view", "recentUpload");
        } else if (currentView === "recentUpload") {
          localStorage.setItem("view", "recentUpload");
        } else if (currentView === "settings") {
          localStorage.setItem("view", "settings");
        } else {
          localStorage.setItem("view", "upload");
        }
        return allCases;

      } else if (response.data?.user_approval_status === 2 || response.data?.user_approval_status === 0) {
        handleshowApproval(response.data?.user_approval_status || 2);
        return [];
      } else if (response.data?.user_approval_status === 3) {
        handleshowApproval(response.data?.user_approval_status || 3);
        return [];
      }
    } catch (error) {
      console.error("Error fetching cases:", error);
      return [];
    }
  };

  // useEffect(() => {
  //   let intervalId;

  //   const checkCases = async () => {
  //     const result = await fetchAllCases();

  //     const approvalStatus = localStorage.getItem("view");
  //     if (approvalStatus === "approvalpage") {
  //       // start polling if status 2 or 0
  //       if (!intervalId) {
  //         intervalId = setInterval(fetchAllCases, 10000); // every 10 sec
  //       }
  //     } else {
  //       // stop polling if approved
  //       if (intervalId) {
  //         clearInterval(intervalId);
  //         intervalId = null;
  //       }
  //     }
  //   };

  //   checkCases();

  //   return () => {
  //     if (intervalId) {
  //       clearInterval(intervalId);
  //     }
  //   };
  // }, []);


  const [tokensData, setTokensData] = useState([]);
  const fetchTokenDeatils = async () => {
    if (localStorage.getItem("userid") && localStorage.getItem("userid") != "" && localStorage.getItem("userid") != null) {

      axios.get(API_BASE_URL + "tokens?user_id=" + localStorage.getItem("userid"))
        .then(response => {
          const allTokens = response.data || null;

          if (allTokens && allTokens.data) {
            if (allTokens.data) {
              setTokensData(allTokens.data);
            } else {
              setTokensData(null);
            }
          } else {
            setTokensData(null);
          }


          // Example: If you're using React, set it in state
          // setCaseOptions(options);
        })
        .catch(error => {
          console.error("Error fetching cases:", error);
        });
    } else {
      navigate("/")
    }
  }
  // useEffect(() => {
  //   if (!localStorage.getItem("userid")) {
  //     navigate("/");
  //     return;
  //   }

  //   let timeoutId;

  //   const pollCases = async () => {
  //     const Cases = await fetchAllCases();
  //     await fetchTokenDeatils();

  //     const hasIncompleteCases = Cases?.some(
  //       c => c.caseStatus && c.caseStatus[0] !== "100%"
  //     );


  //     if (hasIncompleteCases) {
  //       timeoutId = setTimeout(pollCases, 7000);
  //     }
  //   };

  //   pollCases(); // Start polling immediately

  //   return () => {
  //     if (timeoutId) clearTimeout(timeoutId);
  //   };
  // }, []);

  useEffect(() => {
    if (!localStorage.getItem("userid")) {
      navigate("/");
      return;
    }

    checkAndSchedulePoll();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
  const triggerTokenFetch = () => {
    fetchTokenDeatils();
  }

  // const checkAndSchedulePoll = async () => {
  //   const cases = await fetchAllCases();
  //   await fetchTokenDeatils();

  //   const hasIncompleteCases = cases?.some(
  //     (c) => c.caseStatus && c.caseStatus[0] !== "100%"
  //   );
  //   const approvalStatus = localStorage.getItem("view");


  //   if (hasIncompleteCases || approvalStatus === "approvalpage") {
  //     const id = setTimeout(checkAndSchedulePoll, 7000);
  //     setTimeoutId(id);
  //   } else {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //       setTimeoutId(null);
  //     }
  //   }
  // };
  const checkAndSchedulePoll = async () => {
    try {
      const cases = await fetchAllCases();
      await fetchTokenDeatils();

      const hasIncompleteCases = cases?.some(
        (c) => c.caseStatus && c.caseStatus[0] !== "100%"
      );
      const approvalStatus = localStorage.getItem("view");

      // Continue polling if there are incomplete cases or we're on the approval page
      if (hasIncompleteCases || approvalStatus === "approvalpage") {
        // Clear any previous timeout to prevent multiple overlapping timeouts
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        const id = setTimeout(checkAndSchedulePoll, 7000);
        setTimeoutId(id);
      } else {
        // Clear the polling timeout if conditions are no longer met
        if (timeoutId) {
          clearTimeout(timeoutId);
          setTimeoutId(null);
        }
      }
    } catch (error) {
      console.error("Error in polling:", error);
    }
  };


  const triggerPoll = () => {
    checkAndSchedulePoll();
  };




  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "attesta_timeline_logout") {
        localStorage.clear();
        navigate("/"); // redirect to login/home
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);



  const renderContent = () => {
    if (showApprovalpage) {
      return <Permissionpage approvalstatus={approvalstatus} />;
    } else if (showSettings) {
      return <SettingsPage triggerTokenFetch={triggerTokenFetch} defaultStep={settingsStep} />;
    } else if (showAnalysis) {
      return <Analysis fetchAllCases={triggerPoll} handleShowUploads={handleShowUploads} allCasesData={allCasesData} />;
    } else if (showRecentUpload) {
      return (
        <RecentUploads
          handleShowUploads={handleShowUploads}
          handleContinueClick={handleContinueClick}
          recentCasesData={allCasesData}
        />
      );
    } else {
      return (
        <Upload
          onRegisterReset={setResetUpload}
          handleFileChange={handleFileChange}
          handleFileClose={handleFileClose}
          handleContinueClick={handleContinueClick}
          activateTransition={activateTransition}
          fileUploaded={fileUploaded}
          Logo={Logo}
          fileName={fileName}
          fetchAllCases={triggerPoll}
          tokensData={tokensData}
          handleShowSettings={handleShowSettings}
          setHasUploadInProgress={setHasUploadInProgress}

        />
      );
    }
  };

  return (
    <div className={localStorage.getItem("view") === "upload" ? "welcome-page" : 'custom-page'}>
      <div className="topbar d-print-none">
        <div className="container-fluid px-2">
          <div className="main-wrapper">
            <SideBar
              handleShowRecentUpload={handleShowRecentUpload}
              handleShowUploads={handleShowUploads}
              handleContinueClick={handleContinueClicksidebar}
              handleShowSettings={handleShowSettings}
              recentCasesData={allCasesData}
              tokensData={tokensData}
              handlesupplementClick={OpensupplementModal}
              handleaddagentClick={OpenAddionalagentModal}
              handleaddagentassistantClick={OpenAddionalagentassistantModal}
              handleaddadditionalappsClick={OpenAddionalappsModal}

            />

            {renderContent()}
            {/* <Modal show={showLeaveModal} onHide={() => setShowLeaveModal(false)}
              centered
              backdrop="static"
              dialogClassName="custom-leave-modal"
            >
              <Modal.Header closeButton className="border-0">
                <Modal.Title>Upload in Progress</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-muted fs-6">
                You currently have an upload in progress. Leaving this page will stop your
                upload.
                <br />
                <strong>Do you still want to leave?</strong>
              </Modal.Body>
              <Modal.Footer className="border-0 d-flex justify-content-end gap-2">
                <Button
                  variant="outline-secondary"
                  className="px-4 rounded-pill"
                  onClick={() => setShowLeaveModal(false)}
                >
                  Stay
                </Button>
                <Button
                  variant="danger"
                  className="px-4 rounded-pill"
                  onClick={() => {
                    setShowLeaveModal(false);
                    if (pendingAction) pendingAction();
                  }}
                >
                  Leave
                </Button>
              </Modal.Footer>
            </Modal> */}
            <Modal show={showLeaveModal} onHide={() => setShowLeaveModal(false)}
              centered
              backdrop="static"
              dialogClassName="custom-leave-modal"
              className="upload-mgs-modal"
            >
              {/* <Modal.Header closeButton className="border-0 mb-0">
                <Modal.Title className="modal-title">Upload in Progress</Modal.Title>
              </Modal.Header> */}
              <Modal.Body className="text-center">
                <div className="">

                  <p className="mb-0"> You currently have files uploading in progress. </p>
                  <p className="mb-0"> Leaving this page will interrupt your upload process. </p>
                  <p className="mb-0"> Do you still want to leave? </p>

                </div>
                <div className="mt-4 d-flex justify-content-center gap-2">

                  <Button
                    className="leave-btn m-0"
                    onClick={() => {
                      setShowLeaveModal(false);
                      setHasUploadInProgress(false);
                      handleResetClick();
                      if (pendingAction) pendingAction();
                    }}
                  >
                    Yes, Leave
                  </Button>
                  <Button
                    className="stay-btn m-0"
                    onClick={() => setShowLeaveModal(false)}
                  >
                    No, Stay Here
                  </Button>
                </div>
              </Modal.Body>

            </Modal>

            {issupplementModalOpen &&
              <SupplementFileUploadModal
                issupplementModalOpen={issupplementModalOpen}
                closesupplementModal={closesupplementModal}
                tokensData={tokensData}
                selectedFile={selectedfile}
                handleContinueClick={handleContinueClick}
                fetchAllCases={triggerPoll}
              />
            }
            {isaddionalagentModalOpen &&
              <AddionalAgentselect
                isaddionalagentModalOpen={isaddionalagentModalOpen}
                closeaddionalagentModal={closeAddionalagentModal}
                selectedFile={selectedfile}
                handleContinueClick={handleContinueClick}
                fetchAllCases={triggerPoll}
              />
            }
            {isaddionalagentassistantModalOpen &&
              <AddionalAgentAssistantselect
                isaddionalagentassistantModalOpen={isaddionalagentassistantModalOpen}
                closeaddionalagentassistantModal={closeAddionalagentassistantModal}
                selectedFile={selectedfile}
                handleContinueClick={handleContinueClick}
                fetchAllCases={triggerPoll}
              />
            }
            {isaddionalappsModalOpen &&
              <Addionalappsselect
                isaddionalappsModalOpen={isaddionalappsModalOpen}
                closeAddionalappsModal={closeAddionalappsModal}
                selectedFile={selectedfile}
                handleContinueClick={handleContinueClick}
                fetchAllCases={triggerPoll}
              />
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
